import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";

import Text from "../../../components/ui/Text";
import Touchable from "../../../components/ui/Touchable";
import useNavigateWithParams from "../../../hooks/useNavigateWithParams";

export default function StoryHeader() {
  const { t } = useTranslation();
  const navigateWithParams = useNavigateWithParams();

  return (
    <>
      <Touchable
        className="relative z-40 flex h-11 w-full shrink-0 items-center"
        onClick={() => navigateWithParams()}
      >
        <ChevronLeft className="mx-1 size-6 text-orange" />
      </Touchable>

      <Text className="mx-6 mb-4 shrink-0 text-[22px]">{t("story")}</Text>
    </>
  );
}
